import { Stack } from "@mui/material";
import { MprcStringToHtml } from "components";
import { ButtonBack } from "components/buttons";
import { MprcBoxHeader } from "components/MprcBoxHeader";
import { MprcFormBarHeader } from "components/MprcFormBarHeader";
import React, { useMemo } from "react";
import { useNavigate } from "react-router";
import { DashboardPaths } from "routes/DashboardRouter";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    canBack: boolean;
    title: string | string[];
    subtitle?: string | string[];
    onBack?: () => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Header de navegação dos relatórios.
 * @param props
 */
export const DashHeader: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////

    const { canBack, title, subtitle, onBack } = props;
    const navigate = useNavigate();


    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    const items = useMemo(() => {
        const actions: React.ReactNode[] = [];
        actions.push(
            canBack
                ? <ButtonBack
                    key="btnBack"
                    rounded
                    size="large"
                    variant="text"
                    onClick={() => onBack ? onBack() : navigate(DashboardPaths.Home)}
                />
                : <div></div>
        );


        actions.push(
            <Stack direction="column" alignItems="end">
                <MprcStringToHtml
                    text={title}
                    separator={<span>&nbsp;&bull;&nbsp;</span>}
                    color="muted"
                    typographProps={{ variant: "h2" }}
                />
                <MprcStringToHtml text={subtitle} separator={<span>&nbsp;&bull;&nbsp;</span>}
                    typographProps={{ variant: "subtitle2" }}
                />
            </Stack>
        );

        return actions;
    }, [props]);

    return (
        <MprcBoxHeader>
            <MprcFormBarHeader actions={items} />
        </MprcBoxHeader>
    );
};
